module.exports = __webpack_public_path__ + "static/Countertop Ads and Brochures Specs 2026-8c13714e0babcd69881cc6b5b91a2b68.pdf";